export function getLastMonthStartAndEnd(index=1) { // 获取过去几个月时间
      const today = new Date();
      const days=index*30
      const pastDate = new Date(today);
      pastDate.setDate(today.getDate() - days);
      return { startTime:formatDate(today), endTime:formatDate(pastDate) };
  }
  
  export function formatDate(date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1; // 月份是从0开始的
    let day = date.getDate();
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    return `${year}-${month}-${day}`;
  }
  export function generateUniqueId() { // 创建唯一ID
      const array = new Uint32Array(2);
      window.crypto.getRandomValues(array);
      return `id_${array[0]}_${array[1]}`;
  }
  export function deepClone(obj) {
    // 处理基本数据类型和null
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
  
    // 处理数组
    if (Array.isArray(obj)) {
      const newArr = [];
      for (let i = 0; i < obj.length; i++) {
        newArr[i] = deepClone(obj[i]);
      }
      return newArr;
    }
  
    // 处理对象
    if (obj instanceof Object) {
      const newObj = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          newObj[key] = deepClone(obj[key]);
        }
      }
      return newObj;
    }
  
    throw new Error('Unsupported type');
  }